import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import SocialList from "components/shared/SocialList"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFacebookF, faXTwitter, faInstagram, faYoutube, faTiktok } from "@fortawesome/free-brands-svg-icons"

const Social = (props) => {
	const data = useStaticQuery(graphql`
		query {
			allWp {
				edges {
					node {
						...optionsFragment
					}
				}
			}
		}
	`)

	const { 
		socialFacebookGlobal,
		socialTwitterGlobal,
		socialInstagramGlobal,
		socialYoutubeGlobal,
		socialTiktokGlobal
	} = data.allWp.edges[0]?.node?.options?.acfOptions

	return(
		<SocialList>
			{socialFacebookGlobal &&
				<li>
					<a href={socialFacebookGlobal} target="_blank" rel="noopener noreferrer">
						<span className="sr-only">Facebook</span>
						<FontAwesomeIcon icon={faFacebookF} />
					</a>
				</li>
			}
			{socialTwitterGlobal &&
				<li>
					<a href={socialTwitterGlobal} target="_blank" rel="noopener noreferrer">
						<span className="sr-only">Twitter</span>
						<FontAwesomeIcon icon={faXTwitter} />
					</a>
				</li>
			}
			{socialInstagramGlobal &&
				<li>
					<a href={socialInstagramGlobal} target="_blank" rel="noopener noreferrer">
						<span className="sr-only">Instagram</span>
						<FontAwesomeIcon icon={faInstagram} />
					</a>
				</li>
			}
			{socialYoutubeGlobal &&
				<li>
					<a href={socialYoutubeGlobal} target="_blank" rel="noopener noreferrer">
						<span className="sr-only">Youtube</span>
						<FontAwesomeIcon icon={faYoutube} />
					</a>
				</li>
			}
			{socialTiktokGlobal &&
				<li>
					<a href={socialTiktokGlobal} target="_blank" rel="noopener noreferrer">
						<span className="sr-only">Tiktok</span>
						<FontAwesomeIcon icon={faTiktok} />
					</a>
				</li>
			}
		</SocialList>
	)
}

export default Social